@if (!isDesktop()) {
  <app-header
    [transparent]="false"
    [title]="
      plant() ? i18n.parse(plant().objectName) : i18n.langString('plant')
    "
  >
  </app-header>
}
@if (!isDesktop() && plant()) {
  <div class="header">
    @if (true || plant()?.thumbnail) {
      <img
        nz-image
        nzDisablePreview
        class="header-img"
        [nzSrc]="
          plant()?.thumbnail ?? 'assets/images/plant_default_picture.png'
        "
        alt="Plant"
      />
      <div class="header-img-gradient"></div>
    }
  </div>
}

<div class="content" [class.desktop]="isDesktop()">
  @if (isDesktop()) {
    <div class="desktop-sidebar">
      <app-sidebar
        [showFilter]="true"
        [plantsFilter]="true"
        [plantFilterStatus]="filterStatus()"
      >
      </app-sidebar>
    </div>
  }
  <app-plant-overview-content></app-plant-overview-content>
</div>
